import React from 'react'
import PropTypes from 'prop-types'

import { isEmpty } from 'lodash'

import LinkField from 'components/LinkField'

import SelectedLocation from './SelectedLocation'
import MeetingLinkIcon from './MeetingLinkIcon'

import './index.scss'

const MeetingLinkInput = ({ meetingLink, onChange }) => {
  const requiresEdit = isEmpty(meetingLink)
  const [isEditing, setIsEditing] = React.useState(requiresEdit)
  const [hasValidLink, setHasValidLink] = React.useState(false)
  const stopEditing = () => {
    if (!isEmpty(meetingLink) && hasValidLink) {
      setTimeout(() => setIsEditing(false), 100)
    }
  }

  const updateValue = (value, isValid) => {
    setHasValidLink(isValid)
    onChange(value)
  }

  if (isEditing) {
    return (
      <LinkField
        url={meetingLink}
        placeholder="Share a virtual meeting URL"
        onChange={(value, isValid) => updateValue(value, isValid)}
        onSubmit={stopEditing}
        autoFocus
      />
    )
  }
  return (
    <SelectedLocation
      canEdit
      onEdit={() => setIsEditing(true)}
    >
      <MeetingLinkIcon meetingLink={meetingLink} />
      <span className="mli-entered-meeting-link">{meetingLink}</span>
    </SelectedLocation>
  )
}
MeetingLinkInput.propTypes = {
  meetingLink: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}
MeetingLinkInput.defaultProps = {
  meetingLink: '',
}

export default MeetingLinkInput
